
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { colorSet } from '../../models/ui.models';



export class DropdownItem {
  label: string;
  iconSvg?: string;
  iconLabel?: string
  colorSet: colorSet = 'primary';
  colorSetHover?: colorSet = 'primary';
  action?: () => void | Promise<void>;
  routerLink?: string | any[];
  href?: string;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename' | undefined;
  disabled?: boolean;
  forceHide?: boolean;
}
@Component({
  selector: 'app-dynamic-dropdown',
  templateUrl: './dynamic-dropdown.component.html',
  styleUrls: ['./dynamic-dropdown.component.css']
})
export class DynamicDropdownComponent implements OnInit {
  @Output() DropdownEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() dropdownItems: DropdownItem[] = [

  ]
  constructor() { }

  ngOnInit() {
  }

  onDropdownEvent(value: any) {
    this.DropdownEvent.emit(value);
    
  }

}
